<template>
  <div class="orders-view">
    <div class="nav-bar-operations">
      <img src="@/assets/logogruas.png" alt="HomePage" @click="backMainPanel" class="logo-button" />
    </div>
    <div class="top-spacer"></div>

    <div class="panel-head">
      <div class="head-left">
        <h3>Maestro de incidencias de empleado</h3>
      </div>
      <div class="head-actions">
        <button v-if="canCreateIncident" type="button" class="btn-primary" @click="openCreateIncidentModal">
          Crear nueva incidencia
        </button>
        <img src="@/assets/filtros.png" alt="filtros" class="head-icon" />
      </div>
    </div>

    <form class="filters-card" @submit.prevent="queryIncidents">
      <div class="row">
        <label for="employee_ident">Empleado (ID)</label>
        <input id="employee_ident" type="text" v-model="employeeIdent" placeholder="Ej: 1234" />
        <div class="cell span-2"></div>
      </div>

      <div class="row">
        <label for="employee_name">Empleado (Nombre)</label>
        <input id="employee_name" type="text" v-model="employeeName" placeholder="Nombre o apellidos" />
        <div class="cell span-2"></div>
      </div>

      <div class="row">
        <label>Nivel</label>
        <div class="chips">
          <label class="chip" v-for="option in levelOptions" :key="option.value">
            <input type="checkbox" :value="option.value" v-model="selectedLevels" />
            <span>{{ option.label }}</span>
          </label>
        </div>
      </div>

      <div class="row">
        <label for="type">Tipo</label>
        <input id="type" type="text" v-model="incidentType" placeholder="Tipo de incidencia" />
        <div class="cell span-2"></div>
      </div>

      <div class="row">
        <label for="unit">Unidad</label>
        <input id="unit" type="text" v-model="unitShortId" placeholder="# Económico" />
        <div class="cell span-2"></div>
      </div>

      <div class="row">
        <label for="clerk">Elabora</label>
        <input id="clerk" type="text" v-model="clerk" placeholder="Nombre o ID de capturista" />
        <div class="cell span-2"></div>
      </div>

      <div class="row">
        <label>Fecha de ocurrencia</label>
        <input type="datetime-local" v-model="occurrenceStart" />
        <span class="sep">al</span>
        <input type="datetime-local" v-model="occurrenceEnd" />
      </div>

      <div class="row">
        <label for="punishment_date">Fecha correctiva</label>
        <input id="punishment_date" type="date" v-model="punishmentDate" />
        <div class="cell span-2"></div>
      </div>

      <div class="row actions">
        <div class="cell span-4">
          <button type="submit" class="btn-primary">Aplicar filtros</button>
        </div>
      </div>
    </form>

    <section class="results-card" id="results-section">
      <div v-if="!canViewTable" class="no-access">No tienes permisos para ver el listado de incidencias.</div>
      <div class="results-head">
        <h2>Resultados: {{ totalCount }}</h2>
      </div>

      <div v-if="canViewTable" class="table-scroll">
        <table class="table">
          <thead>
            <tr>
              <th @click="toggleSort('request_time')">Creación <span v-if="isSorted('request_time')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span><span v-else>↕</span></th>
              <th @click="toggleSort('occurrence_time')">Ocurrencia <span v-if="isSorted('occurrence_time')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span><span v-else>↕</span></th>
              <th @click="toggleSort('employee_ident')">Empleado <span v-if="isSorted('employee_ident')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span><span v-else>↕</span></th>
              <th @click="toggleSort('level')">Nivel <span v-if="isSorted('level')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span><span v-else>↕</span></th>
              <th @click="toggleSort('type')">Tipo <span v-if="isSorted('type')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span><span v-else>↕</span></th>
              <th>Estatus</th>
              <th @click="toggleSort('clerk')">Elabora <span v-if="isSorted('clerk')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span><span v-else>↕</span></th>
              <th @click="toggleSort('unit_short_id')">Unidad <span v-if="isSorted('unit_short_id')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span><span v-else>↕</span></th>
              <th @click="toggleSort('cost')">Costo <span v-if="isSorted('cost')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span><span v-else>↕</span></th>
              <th @click="toggleSort('punishment_date')">Fecha correctiva <span v-if="isSorted('punishment_date')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span><span v-else>↕</span></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="incident in queriedIncidents" :key="incident.id" class="row-click" @click="openIncidentDetails(incident)">
              <td>{{ formatDateTime(incident.request_time) }}</td>
              <td>{{ formatDateTime(incident.occurrence_time) }}</td>
              <td>{{ incident.employee_involved_ident }} - {{ incident.employee_involved_name }}</td>
              <td>{{ levelLabel(incident.level) }}</td>
              <td>{{ incident.type || 'N/A' }}</td>
              <td>
                <span class="status-pill" :class="incidentStatusClass(incident.status)">
                  {{ incident.status || 'En revision' }}
                </span>
              </td>
              <td>{{ incident.data_entry_clerk_ident }} - {{ incident.data_entry_clerk_name }}</td>
              <td>{{ incident.unit_short_id || 'Sin unidad' }}</td>
              <td>{{ incident.cost ?? 'N/A' }}</td>
              <td>{{ incident.punishment_date || 'N/A' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="pagination">
        <button @click="prevPage" :disabled="currentPage === 1" class="pg-btn" aria-label="Página anterior">
          <img src="@/assets/angulo-izquierdo.png" alt="Previous Page" />
        </button>
        <span v-for="pageNumber in totalPages" :key="pageNumber" @click="goToPage(pageNumber)" :class="['pg-num', { active: pageNumber === currentPage }]">
          {{ pageNumber }}
        </span>
        <button @click="nextPage" :disabled="currentPage >= totalPages" class="pg-btn" aria-label="Página siguiente">
          <img src="@/assets/angulo-derecho.png" alt="Next Page" />
        </button>
      </div>
    </section>

    <div v-if="showIncidentDetailsModal && selectedIncident" class="modal-backdrop" @click.self="closeIncidentDetailsModal">
      <div class="modal-card">
        <div class="modal-head">
          <h4>Incidencia #{{ selectedIncident.id }}</h4>
          <button type="button" class="btn-close" @click="closeIncidentDetailsModal">X</button>
        </div>
        <div class="modal-body">
          <div class="incident-grid">
            <div class="field">
              <label>Fecha de creación</label>
              <input type="text" :value="formatDateTime(selectedIncident.request_time)" disabled />
            </div>
            <div class="field">
              <label>Fecha de ocurrencia</label>
              <input v-if="isEditingIncident" type="datetime-local" v-model="editIncidentDraft.occurrence_time" />
              <input v-else type="text" :value="formatDateTime(selectedIncident.occurrence_time)" disabled />
            </div>
            <div class="field">
              <label>Empleado</label>
              <input type="text" :value="selectedIncident.employee_involved_ident + ' - ' + selectedIncident.employee_involved_name" disabled />
            </div>
            <div class="field">
              <label>Categoria</label>
              <select v-if="isEditingIncident" v-model="editIncidentDraft.category">
                <option value="">Todas</option>
                <option v-for="category in incidentCategoryOptions" :key="`edit-category-${category}`" :value="category">
                  {{ category }}
                </option>
              </select>
              <input v-else type="text" :value="getCategoryForIncidentType(selectedIncident.type) || '-'" disabled />
            </div>
            <div class="field">
              <label>Nivel</label>
              <input
                v-if="isEditingIncident"
                type="text"
                :value="levelLabel(editIncidentDraft.level)"
                disabled
              />
              <input v-else type="text" :value="levelLabel(selectedIncident.level)" disabled />
            </div>
            <div class="field">
              <label>Estatus</label>
              <input type="text" :value="selectedIncident.status || 'En revision'" disabled />
            </div>
            <div class="field">
              <label>Tipo</label>
              <select v-if="isEditingIncident" v-model="editIncidentDraft.type">
                <option value="">Selecciona un tipo</option>
                <option v-for="option in editIncidentTypeOptions" :key="`edit-type-${option}`" :value="option">{{ option }}</option>
              </select>
              <input v-else type="text" :value="selectedIncident.type || '-'" disabled />
            </div>
            <div class="field">
              <label>Elabora</label>
              <input type="text" :value="selectedIncident.data_entry_clerk_ident + ' - ' + selectedIncident.data_entry_clerk_name" disabled />
            </div>
            <div class="field">
              <label>Costo</label>
              <input v-if="isEditingIncident" type="number" step="0.01" inputmode="decimal" v-model="editIncidentDraft.cost" />
              <input v-else type="text" :value="selectedIncident.cost ?? '-'" disabled />
            </div>
            <div class="field">
              <label>Unidad</label>
              <select v-if="isEditingIncident" v-model="editIncidentDraft.unit">
                <option :value="null">Sin unidad</option>
                <option v-for="unit in incidentUnits" :key="`edit-unit-${unit.id}`" :value="unit.id">
                  {{ unit.unit_short_id }} - {{ unit.unit_sub_brand }}
                </option>
              </select>
              <input v-else type="text" :value="selectedIncident.unit_short_id ? `${selectedIncident.unit_short_id} - ${selectedIncident.unit_sub_brand || ''}` : 'Sin unidad'" disabled />
            </div>
            <div class="field">
              <label>Fecha correctiva</label>
              <input v-if="isEditingIncident" type="date" v-model="editIncidentDraft.punishment_date" />
              <input v-else type="text" :value="selectedIncident.punishment_date || '-'" disabled />
            </div>
            <div class="field field-full">
              <label>Descripción</label>
              <textarea v-if="isEditingIncident" v-model.trim="editIncidentDraft.description" placeholder="Describe la falta o comportamiento"></textarea>
              <textarea v-else :value="selectedIncident.description || '-'" disabled></textarea>
            </div>
            <div class="field field-full">
              <label>Acción correctiva</label>
              <textarea v-if="isEditingIncident" v-model.trim="editIncidentDraft.punishment_description" placeholder="Describe la acción correctiva"></textarea>
              <textarea v-else :value="selectedIncident.punishment_description || '-'" disabled></textarea>
            </div>
            <div class="field field-full">
              <label>Firma de enterado</label>
              <div v-if="selectedIncident.acknowledgement_signature" class="incident-signature-view">
                <img :src="selectedIncident.acknowledgement_signature" alt="Firma de enterado" />
              </div>
              <div v-else class="incident-signature-empty">Sin firma</div>
            </div>
          </div>
        </div>
        <div class="modal-actions">
          <template v-if="isEditingIncident">
            <button type="button" class="btn-secondary" @click="cancelEditIncident" :disabled="savingIncidentEdits">Cancelar</button>
            <button type="button" class="btn-primary" @click="saveIncidentEdits" :disabled="savingIncidentEdits">
              {{ savingIncidentEdits ? 'Guardando...' : 'Guardar cambios' }}
            </button>
          </template>
          <template v-else>
            <button v-if="canEditIncident" type="button" class="btn-secondary" @click="startEditIncident(selectedIncident)">
              Editar
            </button>
            <button
              v-if="canCloseIncident && !isIncidentClosed(selectedIncident)"
              type="button"
              class="btn-primary"
              @click="closeIncident(selectedIncident)"
              :disabled="closingIncident"
            >
              {{ closingIncident ? 'Cerrando...' : 'Cerrar incidencia' }}
            </button>
          </template>
        </div>
      </div>
    </div>

    <div v-if="showCreateIncidentModal" class="modal-backdrop" @click.self="closeCreateIncidentModal">
      <div class="modal-card modal-card-lg">
        <div class="modal-head">
          <h4>Crear nueva incidencia</h4>
          <button type="button" class="btn-close" @click="closeCreateIncidentModal">X</button>
        </div>
        <div class="modal-body">
          <div class="incident-grid">
            <div class="field">
              <label>Fecha de creación</label>
              <input type="text" :value="new Date().toLocaleString('es-MX')" disabled />
            </div>
            <div class="field">
              <label>Fecha de ocurrencia *</label>
              <input type="datetime-local" v-model="incidentDraft.occurrence_time" />
            </div>
            <div class="field field-full employee-search-wrap">
              <label>Empleado *</label>
              <input
                type="text"
                v-model="employeeSearchTerm"
                placeholder="Buscar por número o nombre"
                @input="searchIncidentEmployees"
                autocomplete="off"
              />
              <ul v-if="incidentEmployeeSuggestions.length" class="suggestions suggestions-employee">
                <li v-for="employee in incidentEmployeeSuggestions" :key="employee.employee_ident" @click="selectIncidentEmployee(employee)">
                  {{ employee.display_name }}
                </li>
              </ul>
              <small v-if="incidentDraft.employee_involved_ident" class="selected-employee">
                Seleccionado: {{ incidentDraft.employee_involved_ident }} - {{ incidentDraft.employee_involved_name || "Sin nombre" }}
              </small>
            </div>
            <div class="field">
              <label>Categoria</label>
              <select v-model="incidentDraft.category">
                <option value="">Todas</option>
                <option v-for="category in incidentCategoryOptions" :key="`new-category-${category}`" :value="category">
                  {{ category }}
                </option>
              </select>
            </div>
            <div class="field">
              <label>Nivel *</label>
              <input type="text" :value="levelLabel(incidentDraft.level)" disabled />
            </div>
            <div class="field">
              <label>Tipo *</label>
              <select v-model="incidentDraft.type">
                <option value="">Selecciona un tipo</option>
                <option v-for="option in newIncidentTypeOptions" :key="option" :value="option">{{ option }}</option>
              </select>
            </div>
            <div class="field">
              <label>Elabora</label>
              <input type="text" :value="currentUserDisplay || 'Autodetectado al guardar'" disabled />
            </div>
            <div class="field">
              <label>Costo</label>
              <input type="number" step="0.01" inputmode="decimal" v-model="incidentDraft.cost" />
            </div>
            <div class="field">
              <label>Unidad</label>
              <select v-model="incidentDraft.unit">
                <option :value="null">Sin unidad</option>
                <option v-for="unit in incidentUnits" :key="unit.id" :value="unit.id">
                  {{ unit.unit_short_id }} - {{ unit.unit_sub_brand }}
                </option>
              </select>
            </div>
            <div class="field">
              <label>Fecha correctiva</label>
              <input type="date" v-model="incidentDraft.punishment_date" />
            </div>
            <div class="field field-full">
              <label>Descripción *</label>
              <textarea v-model.trim="incidentDraft.description" placeholder="Describe la falta o comportamiento"></textarea>
            </div>
            <div class="field field-full">
              <label>Acción correctiva</label>
              <textarea v-model.trim="incidentDraft.punishment_description" placeholder="Describe la acción correctiva"></textarea>
            </div>
          </div>
        </div>
        <div class="modal-actions">
          <button type="button" class="btn-secondary" @click="closeCreateIncidentModal" :disabled="savingIncident">Cancelar</button>
          <button type="button" class="btn-primary" @click="createIncidentFromMaster" :disabled="savingIncident">
            {{ savingIncident ? "Guardando..." : "Guardar incidencia" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import { EMPLOYEE_INCIDENT_CATALOG } from "@/constants/employeeIncidentCatalog";

export default {
  name: "EmployeeIncidentsFilters",
  data() {
    return {
      permissions: [],
      employeeIdent: "",
      employeeName: "",
      selectedLevels: [],
      incidentType: "",
      unitShortId: "",
      clerk: "",
      occurrenceStart: "",
      occurrenceEnd: "",
      punishmentDate: "",
      queriedIncidents: [],
      selectedIncident: null,
      showIncidentDetailsModal: false,
      showCreateIncidentModal: false,
      savingIncident: false,
      closingIncident: false,
      isEditingIncident: false,
      savingIncidentEdits: false,
      editIncidentDraft: {
        occurrence_time: "",
        category: "",
        level: "",
        type: "",
        cost: "",
        unit: null,
        punishment_date: "",
        description: "",
        punishment_description: "",
      },
      currentUserDisplay: "",
      incidentUnits: [],
      employeeSearchTerm: "",
      incidentEmployeeSuggestions: [],
      incidentEmployeeSearchTimer: null,
      incidentDraft: {
        employee_involved_ident: "",
        employee_involved_name: "",
        occurrence_time: "",
        category: "",
        level: "",
        type: "",
        cost: "",
        description: "",
        unit: null,
        punishment_date: "",
        punishment_description: "",
      },
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      sortState: { by: "request_time", dir: "desc" },
      levelOptions: [
        { value: "1", label: "1 - Leve" },
        { value: "2", label: "2 - Moderada" },
        { value: "3", label: "3 - Grave" },
        { value: "4", label: "4 - Muy Grave" },
      ],
    };
  },
  computed: {
    canViewMaster() {
      return this.hasAnyPerm([
        "access_control.ui_access_rrhh_incidents_master",
        "ui_access_rrhh_incidents_master",
      ]);
    },
    canViewTable() {
      return this.hasAnyPerm([
        "access_control.ui_access_rrhh_incidents_table",
        "ui_access_rrhh_incidents_table",
      ]);
    },
    canCreateIncident() {
      return this.hasAnyPerm([
        "access_control.ui_access_rrhh_incidents_create",
        "ui_access_rrhh_incidents_create",
      ]);
    },
    canCloseIncident() {
      return this.hasAnyPerm([
        "access_control.ui_access_rrhh_incidents_close",
        "ui_access_rrhh_incidents_close",
      ]);
    },
    canEditIncident() {
      return this.hasAnyPerm([
        "access_control.ui_access_rrhh_incidents_create",
        "ui_access_rrhh_incidents_create",
      ]);
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.totalCount / this.pageSize));
    },
    incidentCategoryOptions() {
      return [...new Set(EMPLOYEE_INCIDENT_CATALOG.map((row) => row.category))];
    },
    newIncidentTypeOptions() {
      return this.filterIncidentTypesByCategory(this.incidentDraft.category);
    },
    editIncidentTypeOptions() {
      return this.filterIncidentTypesByCategory(this.editIncidentDraft.category);
    },
  },
  watch: {
    "incidentDraft.category"(newCategory) {
      const allowedTypes = this.filterIncidentTypesByCategory(newCategory);
      if (this.incidentDraft.type && !allowedTypes.includes(this.incidentDraft.type)) {
        this.incidentDraft.type = "";
      }
    },
    "editIncidentDraft.category"(newCategory) {
      const allowedTypes = this.filterIncidentTypesByCategory(newCategory);
      if (this.editIncidentDraft.type && !allowedTypes.includes(this.editIncidentDraft.type)) {
        this.editIncidentDraft.type = "";
      }
    },
    "incidentDraft.type"(newType) {
      this.incidentDraft.level = this.getLevelForIncidentType(newType);
    },
    "editIncidentDraft.type"(newType) {
      this.editIncidentDraft.level = this.getLevelForIncidentType(newType);
    },
  },
  mounted() {
    this.loadPermissions();
    if (!this.canViewMaster) {
      Swal.fire("Sin acceso", "No tienes permisos para ver el maestro de incidencias.", "warning");
      this.$router.push({ name: "MainPanel" });
      return;
    }
    this.fetchCurrentUser();
    this.fetchIncidentUnits();
  },
  beforeUnmount() {
    if (this.incidentEmployeeSearchTimer) {
      clearTimeout(this.incidentEmployeeSearchTimer);
      this.incidentEmployeeSearchTimer = null;
    }
  },
  methods: {
    loadPermissions() {
      try {
        this.permissions = JSON.parse(localStorage.getItem("userPermissions")) || [];
      } catch (error) {
        this.permissions = [];
      }
    },
    hasPerm(perm) {
      if (!perm) return false;
      if (this.permissions.includes(perm)) return true;
      return this.permissions.includes(`access_control.${perm}`);
    },
    hasAnyPerm(perms) {
      if (!Array.isArray(perms) || !perms.length) return false;
      return perms.some((perm) => this.hasPerm(perm));
    },
    backMainPanel() {
      this.$router.push({ path: "/main-panel" });
    },
    levelLabel(levelValue) {
      const option = this.levelOptions.find((item) => String(item.value) === String(levelValue || ""));
      return option?.label || levelValue || "N/A";
    },
    getLevelForIncidentType(typeValue) {
      const matched = EMPLOYEE_INCIDENT_CATALOG.find((row) => row.type === typeValue);
      return matched?.level || "";
    },
    isIncidentClosed(incident) {
      return String(incident?.status || "").toLowerCase() === "cerrada";
    },
    incidentStatusClass(statusValue) {
      return this.isIncidentClosed({ status: statusValue }) ? "status-pill--closed" : "status-pill--review";
    },
    async closeIncident(incident) {
      if (!this.canCloseIncident) {
        Swal.fire("Sin acceso", "No tienes permisos para cerrar incidencias.", "warning");
        return;
      }
      if (!incident?.id) return;
      try {
        const apiDirectory = process.env.API_DIRECTORY;
        this.closingIncident = true;
        const response = await axios.post(`${apiDirectory}/employee-incident/${incident.id}/close/`);
        const updatedStatus = response.data?.status || "Cerrada";
        const target = this.queriedIncidents.find((item) => item.id === incident.id);
        if (target) target.status = updatedStatus;
        this.closeIncidentDetailsModal();
      } catch (error) {
        const errorMessage = error.response ? (error.response.data.error || JSON.stringify(error.response.data)) : error.message;
        Swal.fire("Error", errorMessage || "No se pudo cerrar la incidencia.", "error");
      } finally {
        this.closingIncident = false;
      }
    },
    formatDateTime(value) {
      if (!value) return "N/A";
      const parsedDate = new Date(value);
      if (Number.isNaN(parsedDate.getTime())) return String(value);
      return parsedDate.toLocaleString("es-MX");
    },
    orderingParam() {
      if (!this.sortState?.by) return "";
      const prefix = this.sortState.dir === "desc" ? "-" : "";
      return `&ordering=${encodeURIComponent(prefix + this.sortState.by)}`;
    },
    isSorted(field) {
      return this.sortState.by === field;
    },
    toggleSort(field) {
      if (this.sortState.by === field) {
        this.sortState.dir = this.sortState.dir === "asc" ? "desc" : "asc";
      } else {
        this.sortState.by = field;
        this.sortState.dir = "asc";
      }
      this.currentPage = 1;
      this.queryIncidents();
    },
    goToPage(pageNumber) {
      this.currentPage = pageNumber;
      this.queryIncidents();
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage += 1;
      this.queryIncidents();
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage -= 1;
      this.queryIncidents();
    },
    openIncidentDetails(incident) {
      if (!this.canViewTable) {
        Swal.fire("Sin acceso", "No tienes permisos para ver el detalle de incidencias.", "warning");
        return;
      }
      this.selectedIncident = incident;
      this.isEditingIncident = false;
      this.showIncidentDetailsModal = true;
    },
    closeIncidentDetailsModal() {
      this.showIncidentDetailsModal = false;
      this.selectedIncident = null;
      this.isEditingIncident = false;
    },
    toDatetimeLocal(value) {
      if (!value) return "";
      const parsed = new Date(value);
      if (Number.isNaN(parsed.getTime())) return "";
      const pad = (num) => String(num).padStart(2, "0");
      return `${parsed.getFullYear()}-${pad(parsed.getMonth() + 1)}-${pad(parsed.getDate())}T${pad(parsed.getHours())}:${pad(parsed.getMinutes())}`;
    },
    startEditIncident(incident) {
      if (!this.canEditIncident) {
        Swal.fire("Sin acceso", "No tienes permisos para editar incidencias.", "warning");
        return;
      }
      this.editIncidentDraft = {
        occurrence_time: this.toDatetimeLocal(incident.occurrence_time),
        category: this.getCategoryForIncidentType(incident.type),
        level: this.getLevelForIncidentType(incident.type) || (incident.level ? String(incident.level) : ""),
        type: incident.type || "",
        cost: incident.cost ?? "",
        unit: incident.unit ?? null,
        punishment_date: incident.punishment_date || "",
        description: incident.description || "",
        punishment_description: incident.punishment_description || "",
      };
      this.isEditingIncident = true;
    },
    cancelEditIncident() {
      this.isEditingIncident = false;
    },
    async saveIncidentEdits() {
      if (!this.canEditIncident) {
        Swal.fire("Sin acceso", "No tienes permisos para editar incidencias.", "warning");
        return;
      }
      if (!this.selectedIncident?.id) return;
      const mappedLevel = this.getLevelForIncidentType(this.editIncidentDraft.type);
      if (!this.editIncidentDraft.occurrence_time || !this.editIncidentDraft.type || !this.editIncidentDraft.description) {
        Swal.fire("Campos obligatorios", "Completa fecha de ocurrencia, tipo y descripción.", "warning");
        return;
      }
      if (!mappedLevel) {
        Swal.fire("Tipo invalido", "El tipo seleccionado no tiene gravedad configurada.", "warning");
        return;
      }
      try {
        const payload = {
          occurrence_time: this.editIncidentDraft.occurrence_time,
          level: mappedLevel,
          type: this.editIncidentDraft.type,
          cost: this.normalizeDecimalValue(this.editIncidentDraft.cost),
          unit: this.editIncidentDraft.unit || null,
          punishment_date: this.editIncidentDraft.punishment_date || null,
          description: this.editIncidentDraft.description,
          punishment_description: this.normalizeTextValue(this.editIncidentDraft.punishment_description),
        };
        const apiDirectory = process.env.API_DIRECTORY;
        this.savingIncidentEdits = true;
        const response = await axios.put(`${apiDirectory}/employee-incident/${this.selectedIncident.id}/`, payload);
        const updated = response.data || {};
        this.selectedIncident = { ...this.selectedIncident, ...updated };
        const index = this.queriedIncidents.findIndex((item) => item.id === this.selectedIncident.id);
        if (index !== -1) {
          this.queriedIncidents.splice(index, 1, { ...this.queriedIncidents[index], ...updated });
        }
        this.isEditingIncident = false;
        Swal.fire("Guardado", "La incidencia se actualizó correctamente.", "success");
      } catch (error) {
        const errorMessage = error.response ? (error.response.data.error || JSON.stringify(error.response.data)) : error.message;
        Swal.fire("Error", errorMessage || "No se pudo actualizar la incidencia.", "error");
      } finally {
        this.savingIncidentEdits = false;
      }
    },
    resetIncidentDraft() {
      this.incidentDraft = {
        employee_involved_ident: "",
        employee_involved_name: "",
        occurrence_time: "",
        category: "",
        level: "",
        type: "",
        cost: "",
        description: "",
        unit: null,
        punishment_date: "",
        punishment_description: "",
      };
      this.employeeSearchTerm = "";
      this.incidentEmployeeSuggestions = [];
    },
    getCategoryForIncidentType(typeValue) {
      const matched = EMPLOYEE_INCIDENT_CATALOG.find((row) => row.type === typeValue);
      return matched?.category || "";
    },
    filterIncidentTypesByCategory(categoryValue) {
      const normalizedCategory = String(categoryValue || "").trim();
      const rows = normalizedCategory
        ? EMPLOYEE_INCIDENT_CATALOG.filter((row) => row.category === normalizedCategory)
        : EMPLOYEE_INCIDENT_CATALOG;
      return [...new Set(rows.map((row) => row.type))];
    },
    openCreateIncidentModal() {
      if (!this.canCreateIncident) {
        Swal.fire("Sin acceso", "No tienes permisos para crear incidencias.", "warning");
        return;
      }
      this.resetIncidentDraft();
      this.showCreateIncidentModal = true;
    },
    closeCreateIncidentModal() {
      this.showCreateIncidentModal = false;
      this.resetIncidentDraft();
    },
    normalizeDecimalValue(value) {
      if (value === null || value === undefined || value === "") return null;
      return value;
    },
    normalizeTextValue(value) {
      if (value === null || value === undefined || value === "") return null;
      return String(value).trim();
    },
    async fetchCurrentUser() {
      try {
        const apiDirectory = process.env.API_DIRECTORY;
        const response = await axios.get(`${apiDirectory}/current-user/`);
        const data = response.data || {};
        this.currentUserDisplay =
          data.employee_name ||
          data.employee_full_name ||
          data.full_name ||
          (data.first_name || data.last_name ? `${data.first_name || ""} ${data.last_name || ""}`.trim() : "") ||
          data.username ||
          "";
      } catch (error) {
        this.currentUserDisplay = "";
      }
    },
    async fetchIncidentUnits() {
      try {
        const apiDirectory = process.env.API_DIRECTORY;
        const response = await axios.get(`${apiDirectory}/employee-incident-unit-options/`);
        this.incidentUnits = Array.isArray(response.data?.results) ? response.data.results : [];
      } catch (error) {
        this.incidentUnits = [];
      }
    },
    searchIncidentEmployees() {
      const search = String(this.employeeSearchTerm || "").trim();
      this.incidentDraft.employee_involved_ident = "";
      this.incidentDraft.employee_involved_name = "";
      if (this.incidentEmployeeSearchTimer) clearTimeout(this.incidentEmployeeSearchTimer);
      if (search.length < 2) {
        this.incidentEmployeeSuggestions = [];
        return;
      }
      this.incidentEmployeeSearchTimer = setTimeout(() => {
        this.fetchIncidentEmployeeSuggestions(search);
      }, 250);
    },
    async fetchIncidentEmployeeSuggestions(search) {
      try {
        const apiDirectory = process.env.API_DIRECTORY;
        const response = await axios.get(`${apiDirectory}/employee-incident-employee-options/`, {
          params: { q: search },
        });
        this.incidentEmployeeSuggestions = Array.isArray(response.data?.results) ? response.data.results : [];
      } catch (error) {
        this.incidentEmployeeSuggestions = [];
      }
    },
    selectIncidentEmployee(employee) {
      this.incidentDraft.employee_involved_ident = employee.employee_ident;
      this.incidentDraft.employee_involved_name = employee.full_name || "";
      this.employeeSearchTerm = employee.display_name;
      this.incidentEmployeeSuggestions = [];
    },
    async createIncidentFromMaster() {
      try {
        if (!this.canCreateIncident) {
          Swal.fire("Sin acceso", "No tienes permisos para crear incidencias.", "warning");
          return;
        }
        if (!this.incidentDraft.employee_involved_ident) {
          Swal.fire("Empleado obligatorio", "Selecciona un empleado para la incidencia.", "warning");
          return;
        }
        const mappedLevel = this.getLevelForIncidentType(this.incidentDraft.type);
        if (!this.incidentDraft.occurrence_time || !this.incidentDraft.type || !this.incidentDraft.description) {
          Swal.fire("Campos obligatorios", "Completa empleado, fecha de ocurrencia, tipo y descripción.", "warning");
          return;
        }
        if (!mappedLevel) {
          Swal.fire("Tipo invalido", "El tipo seleccionado no tiene gravedad configurada.", "warning");
          return;
        }
        const payload = {
          occurrence_time: this.incidentDraft.occurrence_time,
          level: mappedLevel,
          type: this.incidentDraft.type,
          cost: this.normalizeDecimalValue(this.incidentDraft.cost),
          description: this.incidentDraft.description,
          unit: this.incidentDraft.unit || null,
          punishment_date: this.incidentDraft.punishment_date || null,
          punishment_description: this.normalizeTextValue(this.incidentDraft.punishment_description),
        };
        const apiDirectory = process.env.API_DIRECTORY;
        this.savingIncident = true;
        await axios.post(`${apiDirectory}/employee-incidents/${this.incidentDraft.employee_involved_ident}/`, payload);
        this.closeCreateIncidentModal();
        Swal.fire("Guardado", "La incidencia se registró correctamente.", "success");
        this.currentPage = 1;
        await this.queryIncidents();
      } catch (error) {
        const errorMessage = error.response ? (error.response.data.error || JSON.stringify(error.response.data)) : error.message;
        Swal.fire("Error", errorMessage || "No se pudo registrar la incidencia.", "error");
      } finally {
        this.savingIncident = false;
      }
    },
    async queryIncidents() {
      if (!this.canViewTable) {
        Swal.fire("Sin acceso", "No tienes permisos para ver incidencias.", "warning");
        return;
      }
      const payload = {
        employee_ident: this.employeeIdent,
        employee_name: this.employeeName,
        level: this.selectedLevels,
        type: this.incidentType,
        unit_short_id: this.unitShortId,
        clerk: this.clerk,
        occurrence_start: this.occurrenceStart || "",
        occurrence_end: this.occurrenceEnd || "",
        punishment_date: this.punishmentDate || "",
      };
      const orderingQS = this.orderingParam();
      try {
        const apiDirectory = process.env.API_DIRECTORY;
        const url = `${apiDirectory}/get-employee-incidents-filtered?page=${this.currentPage}&page_size=${this.pageSize}${orderingQS}`;
        const response = await axios.post(url, payload);
        this.queriedIncidents = response.data.results || [];
        this.totalCount = response.data.count || 0;
        this.$nextTick(() => {
          const el = document.getElementById("results-section");
          if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        });
      } catch (error) {
        const errorMessage = error.response ? (error.response.data.error || JSON.stringify(error.response.data)) : error.message;
        Swal.fire({ icon: "error", title: "Error generando reporte", text: errorMessage });
      }
    },
  },
};
</script>

<style scoped>
:root {
  --brand: #ffc434;
  --brand-600: #e6b12e;
  --bg: #f7f7f8;
  --card: #ffffff;
  --border: #e8e8ea;
  --muted: #70737a;
  --text: #1f2328;
  --radius-sm: 6px;
  --radius-md: 10px;
  --shadow-1: 0 1px 6px rgba(0, 0, 0, 0.06);
}

.orders-view { background: var(--bg); min-height: 100%; }
.no-access { margin: 16px 0; padding: 12px; border-radius: 10px; border: 1px solid #f3c7c7; background: #fff3f3; color: #9b1c1c; font-weight: 700; }
.nav-bar-operations { position: fixed; top: 0; left: 0; width: 100%; height: 56px; background: var(--brand); z-index: 1000; box-shadow: var(--shadow-1); }
.logo-button { position: absolute; height: 80%; top: 50%; left: 50%; transform: translate(-50%, -50%); cursor: pointer; margin: 0; }
.top-spacer { height: 56px; }
.panel-head { margin: 10px 10px 8px; padding: 6px 8px; display: flex; align-items: center; justify-content: space-between; }
.panel-head h3 { margin: 0; font-size: 14px; color: var(--text); letter-spacing: 0.2px; }
.head-icon { width: 22px; height: 22px; opacity: 0.9; }
.head-actions { display: flex; align-items: center; gap: 10px; }
.filters-card { margin: 0 10px 10px; background: var(--card); border: 1px solid var(--border); border-radius: 8px; box-shadow: var(--shadow-1); padding: 8px; display: grid; grid-template-columns: 1fr; gap: 6px; font-size: 12px; }
.filters-card .row { display: grid; grid-template-columns: 140px 320px 22px 320px; align-items: center; gap: 4px; min-height: 28px; }
.filters-card .row.actions { grid-template-columns: 1fr; margin-top: 2px; }
.filters-card label { color: var(--text); font-size: 12px; white-space: nowrap; }
.filters-card .sep { text-align: center; color: var(--muted); font-size: 11px; }
.filters-card input[type="text"], .filters-card input[type="date"], .filters-card input[type="datetime-local"], .filters-card select {
  height: 26px; padding: 0 8px; border: 1px solid #d2d2d2; border-radius: var(--radius-sm); font-size: 12px; outline: none; background: #fff;
}
.chips { grid-column: 2 / -1; display: flex; gap: 6px; flex-wrap: wrap; }
.chip { display: inline-flex; align-items: center; gap: 6px; padding: 4px 8px; border: 1px solid var(--border); border-radius: var(--radius-md); background: #fafafa; font-size: 11.5px; cursor: pointer; }
.chip input { width: 14px; height: 14px; margin: 0; }
.btn-primary { padding: 6px 12px; font-size: 12px; border-radius: 8px; background: var(--brand); border: none; cursor: pointer; box-shadow: var(--shadow-1); }
.btn-primary:hover { background: var(--brand-600); }
.results-card { margin: 0 10px 16px; background: var(--card); border: 1px solid var(--border); border-radius: 8px; box-shadow: var(--shadow-1); overflow: hidden; }
.results-head { padding: 8px 10px; border-bottom: 1px solid var(--border); }
.results-head h2 { font-size: 14px; margin: 0; color: var(--text); }
.table-scroll { overflow-x: auto; }
.table { width: 100%; border-collapse: collapse; font-size: 12px; line-height: 1.15; }
.table thead th { position: sticky; top: 0; z-index: 1; background: #f5f6f8; color: #475163; font-weight: 600; border-bottom: 1px solid var(--border); padding: 6px 8px; white-space: nowrap; cursor: pointer; }
.table tbody td { padding: 5px 8px; border-bottom: 1px solid #f0f0f0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.table tbody tr:nth-child(even) td { background: #fcfcfd; }
.table tbody tr:hover td { background: #eef3ff; color: #0f172a; }
.row-click { cursor: pointer; }
.badge { display: inline-block; padding: 2px 8px; border-radius: var(--radius-sm); font-size: 11px; line-height: 1.3; border: 1px solid transparent; }
.status-pill { display: inline-flex; align-items: center; padding: 3px 9px; border-radius: 999px; font-size: 11px; font-weight: 800; border: 1px solid transparent; white-space: nowrap; }
.status-pill--review { background: #fef3c7; color: #92400e; border-color: #fcd34d; }
.status-pill--closed { background: #dcfce7; color: #166534; border-color: #86efac; }
.incident-signature-view { border: 1px solid var(--border); border-radius: 8px; background: #fff; padding: 8px; display: flex; justify-content: center; }
.incident-signature-view img { max-width: 100%; max-height: 200px; object-fit: contain; }
.incident-signature-empty { border: 1px dashed #cbd5e1; border-radius: 8px; padding: 14px; text-align: center; color: #94a3b8; font-size: 12px; background: #fafafa; }
.badge-id { background: var(--brand); color: #000; font-weight: 700; border: 1px solid #f0c35a; }
.pagination { display: flex; flex-wrap: wrap; justify-content: center; align-items: center; gap: 6px; padding: 10px; border-top: 1px solid var(--border); }
.pg-btn { background: #fff; border: 1px solid var(--border); border-radius: 8px; padding: 2px 6px; cursor: pointer; box-shadow: var(--shadow-1); }
.pg-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.pg-btn img { width: 18px; height: auto; display: block; }
.pg-num { min-width: 28px; text-align: center; padding: 4px 8px; border-radius: 8px; border: 1px solid var(--border); background: #fff; cursor: pointer; user-select: none; }
.pg-num.active { background: var(--brand); border-color: #e0b12b; }

.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3000;
  padding: 16px;
}
.modal-card {
  width: min(900px, 100%);
  max-height: calc(100vh - 32px);
  overflow: auto;
  background: #fff;
  border-radius: 10px;
  border: 1px solid var(--border);
  box-shadow: var(--shadow-1);
}
.modal-card-lg { width: min(980px, 100%); }
.modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-bottom: 1px solid var(--border);
}
.modal-head h4 { margin: 0; font-size: 14px; }
.btn-close {
  border: 1px solid var(--border);
  background: #f8f8f8;
  border-radius: 6px;
  padding: 4px 8px;
  cursor: pointer;
}
.modal-body { padding: 12px; }
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 12px;
  border-top: 1px solid var(--border);
}
.btn-secondary {
  padding: 6px 12px;
  font-size: 12px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: #f5f5f5;
  cursor: pointer;
}
.incident-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}
.field { display: flex; flex-direction: column; gap: 4px; }
.field label { font-size: 11px; font-weight: 700; color: var(--text); }
.field input, .field select, .field textarea {
  width: 100%;
  border: 1px solid #d2d2d2;
  border-radius: 6px;
  padding: 6px 8px;
  font-size: 12px;
  background: #fff;
}
.field textarea {
  min-height: 80px;
  resize: vertical;
}
.field-full { grid-column: 1 / -1; }
.employee-search-wrap { position: relative; }
.suggestions-employee {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 8px;
  box-shadow: var(--shadow-1);
  z-index: 20;
  list-style: none;
  margin: 0;
  padding: 4px 0;
}
.suggestions-employee li {
  padding: 6px 10px;
  font-size: 12px;
  cursor: pointer;
}
.suggestions-employee li:hover { background: #f2f6ff; }
.selected-employee {
  color: var(--muted);
  font-size: 11px;
}

@media (max-width: 1200px) {
  .filters-card .row { grid-template-columns: 120px minmax(180px, 1fr) 18px minmax(180px, 1fr); }
}
@media (max-width: 900px) {
  .filters-card .row { grid-template-columns: 120px 1fr; }
  .filters-card .sep, .filters-card .row > .cell { display: none; }
  .incident-grid { grid-template-columns: 1fr; }
}
</style>
